enum StatusBoardCardItem {
  VEHICLE,
  CONTACTS,
  MECHANICS,
  WORK_PREPARATION,
  PARTS_PICKING,
  CLEANING,
  QUALITY_CONTROL,
  INVOICE,
  PAYMENT,
  WARRANTY,
  PRECHECKIN
}

export default StatusBoardCardItem;